const LANDING_PAGE_PENSION_HREF = 'https://lp.warren.com.br/previdencia';

export const beforeEnterPension = () => {
  window.location.href = LANDING_PAGE_PENSION_HREF;
};
